import React from "react";
import { renderRichText, StoryblokComponent, storyblokEditable } from "@storyblok/react";
import
  {
    ProductModel,
    SectorModel,
    ShowcasePanelModel,
  } from "./ShowcasePanelModel";

import "./ShowcasePanel.css";
import Utils from "../../core/Utils/Utils";

const ShowcasePanel: React.FC<{ blok: ShowcasePanelModel }> = ({ blok }) => 
{
  const entity = blok.entity[0].content;
  const isProductEntity = (): boolean =>
  {
    return (entity as ProductModel).productName !== undefined;
  };
  const isVideo = blok.media?.filename?.endsWith(".mp4");

  const getName = (): string => 
  {
    if (isProductEntity())
    {
      return (entity as ProductModel).productName;
    }
    return (entity as SectorModel).sectorName;
  };

  const getTagline = (): string => 
  {
    if (isProductEntity())
    {
      return (entity as ProductModel).tagLine;
    }
    return (entity as SectorModel).sectorTagline;
  };

  const getDescription = (): React.ReactNode => 
  {
    if (isProductEntity()) 
    {
      const field = (entity as ProductModel).richDescription;
      if (!field?.content || field.content.length === 0)
      {
        return (<>{(entity as ProductModel).description}</>);
      }

      // v4.3.3 of renderRichText returns a string that react encodes
      // v5 returns jsx but as we're still on v4.3.3, inject the html in to avoid the encode

      return <div dangerouslySetInnerHTML={{ __html: renderRichText(field) || "" }} />;
    }

    return (<>{(entity as SectorModel).sectorDescription}</>);
  };

  return (
    <div
      {...storyblokEditable(blok)}
      className={`showcase-panel ${blok.display}`}
    >
      {isVideo && (
        <video
          autoPlay
          loop
          muted
          playsInline
          src={Utils.getCacheUrl(blok.media?.filename)}
          data-object-fit="cover"
          onError={(e) => Utils.handleVideoError(e, blok.media.filename)}
        ></video>
      )}
      {!isVideo && blok.media?.filename && (
        <img
          src={Utils.getCacheUrl(blok.media.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.media?.filename)}
        />
      )}
      <div className="container">
        <div className="showcase-content">
          <div className="showcase-name">{getName()}</div>
          <div className="tag-line">{getTagline()}</div>
          <div className="description">{getDescription()}</div>
          <div className="showcase-buttons">
            {blok.buttons
              ? blok.buttons.map((button) => (
                <StoryblokComponent
                  blok={button}
                  key={button._uid}
                  className="button"
                />
              ))
              : null}
          </div>
          <div className="supported-on">
            {isProductEntity()
              ? `Supported on ${(entity as ProductModel).os?.join(", ")}`
              : " "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowcasePanel;
